import { useState, useEffect } from 'react';
import { collection, query, where, getDocs } from 'firebase/firestore';
import { db } from '../services/firebase';

export default function usePlayerStats(userId) {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!userId) {
      setStats(null);
      setLoading(false);
      return;
    }

    let cancelled = false;

    async function fetchStats() {
      setLoading(true);
      try {
        const q = query(
          collection(db, 'games'),
          where('playerIds', 'array-contains', userId),
          where('status', '==', 'finished')
        );
        const snapshot = await getDocs(q);

        let totalGames = 0;
        let wins = 0;
        let highestScore = 0;

        snapshot.docs.forEach(doc => {
          const game = doc.data();
          totalGames++;

          if (game.winner?.id === userId) {
            wins++;
          }

          const player = game.players?.find(p => p.id === userId);
          if (player && player.score > highestScore) {
            highestScore = player.score;
          }
        });

        if (!cancelled) {
          setStats({
            totalGames,
            wins,
            winPct: totalGames > 0 ? Math.round((wins / totalGames) * 100) : 0,
            highestScore,
          });
        }
      } catch (e) {
        console.error('Error fetching player stats:', e);
        if (!cancelled) setStats(null);
      } finally {
        if (!cancelled) setLoading(false);
      }
    }

    fetchStats();
    return () => { cancelled = true; };
  }, [userId]);

  return { stats, loading };
}
